module.exports = __webpack_public_path__ + "img/logo.f3463472.png";